import React, { useState, useEffect } from "react";
import { IconDelete } from "../../Icon";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import {
  BankAccountDetails,
  UserProfileType,
} from "../../../redux/auth/authTypes";
import { ACCOUNT_TYPE } from "../../../constant/userProfileConstant";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../assets/images";
import { BankAccountInfoType } from "../../../redux/services/serviceTypes";
import { isIFSCValid } from "../../../utils/commonFunctions";
type AppProps = {
  data: BankAccountDetails[];
  handleBankAccountWorkForm: (data: any) => void;
  getBankDetails?: (data: any) => void;
  resetBankDetailsData?: () => void;
  setProfileForm: any;
  bankAccountDetails?: BankAccountInfoType | null;
  servicesError?: string | null;
  userProfileAllData?: UserProfileType;
  isEdit?: boolean;
};
const BankAccoundDetails = ({
  data,
  handleBankAccountWorkForm,
  setProfileForm,
  getBankDetails,
  bankAccountDetails,
  resetBankDetailsData,
  userProfileAllData,
  isEdit,
  servicesError,
}: AppProps) => {
  const [totalBankAccount, setTotalBankAccount] =
    useState<BankAccountDetails[]>(data);
  const [isHovered, setIsHovered] = useState(false);
  const [bankDetailsIndex, setBankDetailsIndex] = useState<number | null>(null);

  useEffect(() => {
    if (
      bankAccountDetails?.message &&
      totalBankAccount?.length &&
      (bankDetailsIndex === 0 || bankDetailsIndex)
    ) {
      let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
      let temp1 = temp[bankDetailsIndex];
      temp1["bank_verification_details"] = bankAccountDetails;
      setTotalBankAccount((prv: any) => [...temp]);
    } else if (
      totalBankAccount?.length &&
      (bankDetailsIndex === 0 || bankDetailsIndex) &&
      totalBankAccount[bankDetailsIndex]["bank_verification_details"]
    ) {
      let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
      let temp1 = temp[bankDetailsIndex];
      temp1["bank_verification_details"] = null;
      setTotalBankAccount((prv: any) => [...temp]);
    }
  }, [bankAccountDetails]);

  useEffect(() => {
    if (servicesError?.length && (bankDetailsIndex === 0 || bankDetailsIndex)) {
      let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
      let temp1 = temp[bankDetailsIndex];
      temp1["bank_verification_details"] = { error: servicesError };
      setTotalBankAccount((prv: any) => [...temp]);
    }
  }, [servicesError]);

  const handleAddBankAccount = () => {
    if (totalBankAccount?.length < 5) {
      setTotalBankAccount((prv) => [
        ...prv,
        {
          bank_name: "",
          branch_name: "",
          bank_account_number: "",
          ifsc_code: "",
          account_type: "",
          bank_verification_details: null,
        },
      ]);
    }
  };

  const handleDeleteAccount = (index: number) => {
    const temp = JSON.parse(JSON.stringify(totalBankAccount));
    temp.splice(index, 1);
    setTotalBankAccount([...temp]);
    setBankDetailsIndex(null);
    resetBankDetailsData?.();
  };

  const allAccountData = (index: number, e: any, name: string) => {
    if (
      (name === "ifsc_code" || name === "bank_account_number") &&
      e?.target?.value
    ) {
      setBankDetailsIndex(null);
      let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
      let temp1 = temp[index];
      temp1[e.target.name] = e?.target?.value;
      temp1["bank_verification_details"] = null;
      setTotalBankAccount((prv: any) => [...temp]);
      resetBankDetailsData?.();
    } else {
      let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
      let temp1 = temp[index];
      temp1[e.target.name] = e?.target?.value;
      setTotalBankAccount((prv: any) => [...temp]);
    }
  };
  const allAccountTypeData = (index: number, e: any) => {
    let temp: any = JSON.parse(JSON.stringify(totalBankAccount));
    let temp1 = temp[index];
    temp1["account_type"] = e;
    setTotalBankAccount((prv: any) => [...temp]);
  };

  useEffect(() => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        payroll_settings: {
          ...prv?.payroll_settings,
          bank_account_details:
            totalBankAccount?.length > 0
              ? [...totalBankAccount]
              : [
                  {
                    bank_name: "",
                    branch_name: "",
                    bank_account_number: "",
                    ifsc_code: "",
                    account_type: "",
                    bank_verification_details: null,
                  },
                ],
        },
      };
    });
  }, [totalBankAccount]);

  return (
    <>
      <div className="form-group" style={{ marginTop: "15px" }}>
        <p style={{ fontSize: "15px", fontWeight: 500, marginBottom: "6px" }}>
          BANK DETAILS
        </p>
        <h4 style={{ marginBottom: "1px", color: "#5c6177" }}>
          Update your Bank and Details.
        </h4>
        <small
          className="text-danger"
          style={{
            marginTop: "6px",
            fontSize: "12px",
          }}
        >
          You can only add upto 5 bank accounts
        </small>

        {totalBankAccount && totalBankAccount?.length > 0
          ? totalBankAccount?.map((el, index) => {
              return (
                <>
                  {totalBankAccount?.length > 1 && (
                    <h6 className="mt-4">Bank Account 0{index + 1}</h6>
                  )}
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <label htmlFor="email">IFSC Code</label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="text"
                          className={`form-control`}
                          name="ifsc_code"
                          value={data && data[index] && data[index]?.ifsc_code}
                          onChange={(e: any) =>
                            allAccountData(index, e, "ifsc_code")
                          }
                        />
                      </div>
                      {data[index]?.ifsc_code &&
                      el["bank_verification_details"]?.error &&
                      el["bank_verification_details"]?.error?.includes(
                        "Invalid IFSC"
                      ) ? (
                        <span className="text-danger">
                          {el["bank_verification_details"]?.error}
                        </span>
                      ) : null}
                    </div>
                    <div className="col-md-3 position-relative">
                      <label htmlFor="email">Bank Account No.</label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="number"
                          className={`form-control`}
                          value={
                            data &&
                            data[index] &&
                            data[index]?.bank_account_number
                          }
                          name="bank_account_number"
                          onChange={(e: any) =>
                            allAccountData(index, e, "bank_account_number")
                          }
                          onWheel={(event) => event.currentTarget.blur()}
                        />
                        <span
                          className="position-absolute"
                          style={{ top: "7px", right: "5px" }}
                        >
                          {(!isEdit &&
                            !!el["bank_verification_details"]?.account_exists &&
                            el["bank_verification_details"]?.account_exists ===
                              "Yes") ||
                          (isEdit &&
                            (el["bank_verification_details"]?.account_exists ===
                              "Yes" ||
                              (userProfileAllData?.payroll_settings
                                ?.bank_account_details[index]
                                ?.bank_verification_details?.account_exists &&
                                userProfileAllData?.payroll_settings
                                  ?.bank_account_details[index]
                                  ?.bank_verification_details
                                  ?.account_exists === "Yes" &&
                                userProfileAllData?.payroll_settings
                                  ?.bank_account_details[index]
                                  ?.bank_account_number ===
                                  el?.bank_account_number &&
                                userProfileAllData?.payroll_settings
                                  ?.bank_account_details[index]?.ifsc_code ===
                                  el?.ifsc_code))) ? (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-filter-invoice">
                                  <div>
                                    <div className="text-left">
                                      Name at bank :{" "}
                                      {el["bank_verification_details"]
                                        ?.name_at_bank
                                        ? el["bank_verification_details"]
                                            ?.name_at_bank
                                        : userProfileAllData?.payroll_settings
                                            ?.bank_account_details[index]
                                            ?.bank_verification_details
                                            ?.name_at_bank
                                        ? userProfileAllData?.payroll_settings
                                            ?.bank_account_details[index]
                                            ?.bank_verification_details
                                            ?.name_at_bank
                                        : "NA"}
                                    </div>
                                    <div className="text-left">
                                      Account Exists :{" "}
                                      {el["bank_verification_details"]
                                        ?.account_exists
                                        ? el["bank_verification_details"]
                                            ?.account_exists
                                        : data[index][
                                            "bank_verification_details"
                                          ]?.account_exists
                                        ? data[index][
                                            "bank_verification_details"
                                          ]?.account_exists
                                        : "NA"}
                                    </div>
                                  </div>
                                </Tooltip>
                              }
                            >
                              <img src={EnableiIcon} />
                            </OverlayTrigger>
                          ) : (
                            <img src={DisableiIcon} />
                          )}
                        </span>
                      </div>
                      {(!isEdit &&
                        !!el["bank_verification_details"]?.account_exists &&
                        el["bank_verification_details"]?.account_exists ===
                          "Yes") ||
                      (isEdit &&
                        (el["bank_verification_details"]?.account_exists ===
                          "Yes" ||
                          (userProfileAllData?.payroll_settings
                            ?.bank_account_details[index]
                            ?.bank_verification_details?.account_exists &&
                            userProfileAllData?.payroll_settings
                              ?.bank_account_details[index]
                              ?.bank_verification_details?.account_exists ===
                              "Yes" &&
                            userProfileAllData?.payroll_settings
                              ?.bank_account_details[index]
                              ?.bank_account_number ===
                              el?.bank_account_number &&
                            userProfileAllData?.payroll_settings
                              ?.bank_account_details[index]?.ifsc_code ===
                              el?.ifsc_code))) ? (
                        <span>
                          <img src={VerifyIcon} alt="pan" />{" "}
                          <span style={{ color: "#28a745" }}>
                            Bank Details is Verified
                          </span>
                        </span>
                      ) : (el["bank_verification_details"]?.account_exists ===
                          "NO" &&
                          index === bankDetailsIndex) ||
                        userProfileAllData?.payroll_settings
                          ?.bank_account_details[index]
                          ?.bank_verification_details?.account_exists ===
                          "NO" ? (
                        <span className="text-danger">
                          {el["bank_verification_details"]?.message}
                        </span>
                      ) : null}
                    </div>
                    <div className="col-md-2">
                      <div className="form-group" style={{ marginTop: "22px" }}>
                        <button
                          className="btn btn-outline"
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          disabled={!el?.bank_account_number || !el?.ifsc_code}
                          onClick={(e) => {
                            setBankDetailsIndex(index);
                            getBankDetails?.({
                              e,
                              accountNumber: el?.bank_account_number,
                              ifscCode: el?.ifsc_code,
                            });
                          }}
                        >
                          <img
                            src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                            alt="check"
                          />{" "}
                          <span>Verify</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <label htmlFor="email">Bank Name</label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="text"
                          className={`form-control`}
                          name="bank_name"
                          value={
                            data && data[index] && data[index]?.["bank_name"]
                          }
                          onChange={(e: any) =>
                            allAccountData(index, e, "bank_name")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="email">Branch Name</label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="text"
                          className={`form-control`}
                          name="branch_name"
                          value={
                            data && data[index] && data[index]?.branch_name
                          }
                          onChange={(e: any) =>
                            allAccountData(index, e, "branch_name")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="email">Account Type</label>
                      <div className="d-flex align-items-center">
                        <div style={{ width: "100%" }}>
                          <Select<any, false>
                            className="dropdown"
                            placeholder={"Select Account"}
                            value={
                              data &&
                              data[index] &&
                              data[index]?.account_type && {
                                label: data[index]?.account_type,
                                value: data[index]?.account_type,
                              }
                            }
                            options={ACCOUNT_TYPE}
                            onChange={(e) =>
                              allAccountTypeData(index, e?.value)
                            }
                            isSearchable={true}
                          />
                        </div>
                      </div>
                    </div>
                    {totalBankAccount && totalBankAccount?.length > 1 ? (
                      <div
                        className="pointer"
                        style={{
                          display: "flex",
                          marginTop: "25px",
                          padding: "0px 10px",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "4px",
                          height: "37px",
                          border: "solid 1px #bfcbe1",
                        }}
                        onClick={() => handleDeleteAccount(index)}
                      >
                        <IconDelete />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              );
            })
          : ""}
        <div className="row mt-3">
          <div className="col-3">
            <Button
              disabled={totalBankAccount?.length === 5}
              onClick={handleAddBankAccount}
            >
              + Add Bank Account
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankAccoundDetails;
